import * as tslib_1 from "tslib";
import { put, takeLatest, call, select, all } from 'redux-saga/effects';
import { requestFailure, spreadLove, requestSuccessWithRecommendations, requestSuccess, } from './actionCreators';
import { LoveRequestError } from './types';
import { request } from '../../xhr';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { restrictLoggedOut } from '../../redux/loggedout';
import { normalize } from 'normalizr';
import { deviationListSchema } from '../../redux/normalizr/schemas/deviation';
import { getNormalizedDeviationById } from '../../redux/deviations/selectors';
import { updateNormalizedDeviationEntity } from '../../redux/deviations/actionCreators';
function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line global-require
        var deviationsByType = require('@wix/da-sample-data').deviationsByType;
        // eslint-disable-next-line global-require
        var Chance = require('chance').Chance;
        var chance = new Chance();
        return {
            success: true,
            recommendations: {
                hasMore: false,
                deviations: chance.pickset(deviationsByType.image, 24),
            },
        };
    }
    return { success: true };
}
function getError(result) {
    if (result &&
        result.error_code !== undefined &&
        LoveRequestError[result.error_code] !== undefined) {
        return result.error_code;
    }
    return LoveRequestError.CanNotBeLoved;
}
function doSpreadLove(action) {
    var _a, itemId, loveScore, getRecommendations, isLoggedIn, data, normalizedDeviation, oldScore, oldLoveLevel, updatedDeviation, result, recommendations, _b, normalized, entities;
    return tslib_1.__generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!action.payload) {
                    return [2 /*return*/];
                }
                _a = action.payload, itemId = _a.itemId, loveScore = _a.loveScore, getRecommendations = _a.getRecommendations;
                return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _c.sent();
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut())];
            case 2:
                _c.sent();
                return [2 /*return*/];
            case 3:
                data = {
                    deviationid: itemId,
                    love_score: loveScore,
                    recommendations: !!getRecommendations,
                };
                return [4 /*yield*/, select(getNormalizedDeviationById, itemId)];
            case 4:
                normalizedDeviation = _c.sent();
                if (!normalizedDeviation) return [3 /*break*/, 6];
                oldScore = normalizedDeviation.loveScore || 0;
                oldLoveLevel = (normalizedDeviation.stats && normalizedDeviation.stats.loveLevel) || 0;
                updatedDeviation = tslib_1.__assign({}, normalizedDeviation, { loveScore: loveScore, stats: tslib_1.__assign({ comments: 0, favourites: 0 }, normalizedDeviation.stats) });
                if (loveScore > 0 && oldScore <= 0) {
                    updatedDeviation.stats.loveLevel = oldLoveLevel + 1;
                }
                else if (loveScore <= 0 && oldScore > 0) {
                    updatedDeviation.stats.loveLevel = Math.max(0, oldLoveLevel - 1);
                }
                return [4 /*yield*/, put(updateNormalizedDeviationEntity(updatedDeviation))];
            case 5:
                _c.sent();
                _c.label = 6;
            case 6: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: 'love',
                    data: data,
                }, fakeResponse)];
            case 7:
                result = _c.sent();
                if (!(result && result.success)) return [3 /*break*/, 9];
                recommendations = (result.recommendations && result.recommendations.deviations) || [];
                _b = normalize(recommendations, deviationListSchema), normalized = _b.result, entities = _b.entities;
                return [4 /*yield*/, all([
                        put(requestSuccess(itemId, loveScore, recommendations)),
                        put(requestSuccessWithRecommendations(itemId, loveScore, normalized, entities)),
                    ])];
            case 8:
                _c.sent();
                return [3 /*break*/, 12];
            case 9: return [4 /*yield*/, put(requestFailure(itemId, getError(result)))];
            case 10:
                _c.sent();
                if (!normalizedDeviation) return [3 /*break*/, 12];
                return [4 /*yield*/, put(updateNormalizedDeviationEntity(normalizedDeviation))];
            case 11:
                _c.sent();
                _c.label = 12;
            case 12: return [2 /*return*/];
        }
    });
}
function saga() {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(spreadLove, doSpreadLove)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default saga;
//# sourceMappingURL=saga.js.map